export default __webpack_public_path__ + "static/media/sidebarBg.152ceb6f.jpg";